export enum Currency {
  EUR = 'EUR',
  CHF = 'CHF',
  ISK = 'ISK',
  CZK = 'CZK',
  AED = 'AED',
  SEK = 'SEK',
  NOK = 'NOK',
  DKK = 'DKK',
  GBP = 'GBP',
  OMR = 'OMR',
}
